"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var content_parser_1 = require("@dynamynd/content-parser");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var enums_1 = require("../../enums");

var services_1 = require("../../services");

var index_1 = require("../index");

var SectionOverview = react_1.default.forwardRef(function (_a) {
  var type = _a.type,
      description = _a.description,
      imageUrl = _a.imageUrl,
      tubesHeader = _a.tubesHeader,
      naturalAdvantageHeader = _a.naturalAdvantageHeader,
      onLayoutHandler = _a.onLayoutHandler,
      scrollToSectionHandler = _a.scrollToSectionHandler;
  var naturalAdvantageTitleColor = services_1.modulesService.getNaturalAdvantageTitleColor(type);
  var naturalAdvantageAudioKey = services_1.modulesService.getNaturalAdvantageAudioKey(type);

  if (window.location.pathname === '/modules/sampleview' && window.location.search === '?module=41') {
    naturalAdvantageHeader = 'When you spend time helping others do test prep, you take advantage of teaching being one of the best ways of learning. Therefore, doing your thing as a';
  } else if (window.location.pathname === '/modules/sampleview' && window.location.search === '?module=32') {
    naturalAdvantageHeader = 'There’s no way to keep you from feeling not only your own stress, but the stress you sense in others. As a';
  }

  return react_1.default.createElement(index_1.SectionContainer, {
    backgroundColor: "#F6E8D6",
    onLayout: function onLayout(event) {
      var height = event.nativeEvent.layout.height;
      onLayoutHandler(enums_1.ModuleSectionViewsEnum.overview, height);
    }
  }, react_1.default.createElement(index_1.ContentRowResponsive, null, react_1.default.createElement(index_1.ContentRow, null, react_1.default.createElement(components_lib_1.ColumnCenteredResponsive, {
    xl: 50
  }, react_1.default.createElement(components_lib_1.Title, null, react_1.default.createElement(content_parser_1.ParsedContent, {
    content: naturalAdvantageHeader
  })), react_1.default.createElement(index_1.NaturalAdvantageTitle, {
    color: naturalAdvantageTitleColor,
    ellipsizeMode: "tail",
    numberOfLines: 1
  }, type), react_1.default.createElement(OverviewTextContainer, null, react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.big
  }, react_1.default.createElement(content_parser_1.ParsedContent, {
    content: description,
    customBulletPointColor: naturalAdvantageTitleColor
  }))), react_1.default.createElement(components_lib_1.AudioPlayer, {
    uri: components_lib_1.appConfig.audio[naturalAdvantageAudioKey],
    color: naturalAdvantageTitleColor
  })), react_1.default.createElement(components_lib_1.ColumnCenteredResponsive, {
    xl: 50
  }, react_1.default.createElement(TextFixer, null, react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.big
  }, react_1.default.createElement(content_parser_1.ParsedContent, {
    content: tubesHeader
  }))), react_1.default.createElement(index_1.OverallScoreImage, {
    resizeMode: "center",
    source: {
      uri: "data:image/png;base64," + imageUrl
    }
  })))), react_1.default.createElement(index_1.ScrollDown, {
    scrollToSectionHandler: scrollToSectionHandler
  }));
});
var TextFixer = responsive_1.withResponsiveMeta(styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);
  return "\n        max-width: " + (small ? 100 : 70) + "%;\n        margin-bottom: " + (small ? 8 : 0) + "px;\n        " + (!extraLarge ? "\n                    align-self: flex-start;\n                    margin-top: 30px;\n                " : '') + "\n    ";
}));
var OverviewTextContainer = responsive_1.withResponsiveMeta(styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var smallOrMedium = responsive_1.isSmallOrMedium(activeBreakpoint);
  return "\n        margin-top: " + (smallOrMedium ? 27 : 46) + "px;\n        margin-bottom: " + (smallOrMedium ? 16 : 10) + "px;\n    ";
}));
exports.default = SectionOverview;
var templateObject_1, templateObject_2;